/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../models/external_bank_account';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "ListExternalBankAccountsRequest": {
                    "fields": {
                      "customerId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "limit": {
                        "type": "uint32",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": 10
                        }
                      },
                      "cursor": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "ListExternalBankAccountsResponse": {
                    "fields": {
                      "externalBankAccounts": {
                        "type": ".squareup.sfs.external.models.ExternalBankAccount",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "cursor": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 3,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ListExternalBankAccountsRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ListExternalBankAccountsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListExternalBankAccountsRequest @ squareup/sfs/external/services/external_bank_account/list_external_bank_accounts.proto at 9:1
 */
export const ListExternalBankAccountsRequest = $root.lookupType('squareup.sfs.external.service.ListExternalBankAccountsRequest');
fixType(ListExternalBankAccountsRequest, {
  customerId: {
    required: true
  }
});
Builder.createAndAttachToType(ListExternalBankAccountsRequest);
/**
 * SOURCE ListExternalBankAccountsResponse @ squareup/sfs/external/services/external_bank_account/list_external_bank_accounts.proto at 30:1
 */
export const ListExternalBankAccountsResponse = $root.lookupType('squareup.sfs.external.service.ListExternalBankAccountsResponse');
fixType(ListExternalBankAccountsResponse);
Builder.createAndAttachToType(ListExternalBankAccountsResponse);